import { localEnv } from './local';
export const isTestOrLocalDb = () => {
    const nodeEnv = process.env.NODE_ENV;
    const dbEnv = process.env.DB_ENV;
    return nodeEnv === 'test' || (nodeEnv === 'development' && (dbEnv === 'emptylocaldb' || dbEnv === 'localdb'));
};
const getValue = (key) => () => {
    const value = isTestOrLocalDb() ? localEnv[key] : process.env[key];
    if (!value) {
        throw new Error(`${key} was not in env`);
    }
    return value;
};
export const getSupportUserPoolId = getValue('SUPPORT_USER_POOL_ID');
export const getSupportClientId = getValue('SUPPORT_CLIENT_ID');
export const getIgnoreRulesTableName = getValue('IGNORE_RULES_TABLE_NAME');
export const getTrashRulesTableName = getValue('TRASH_RULES_TABLE_NAME');
export const getProcessingEnvironmentId = getValue('PROCESSING_ENVIRONMENT_ID');
export const getSupportOrigin = getValue('SUPPORT_ORIGIN');
export const getSupportCognitoBaseUrl = getValue('SUPPORT_COGNITO_BASE_URL');
export const getCommbotSNSTopicArn = getValue('COMMBOT_SNS_TOPIC_ARN');
export const getAwsRegion = getValue('AWS_REGION');
export const getDataEnvironmentId = getValue('DATA_ENVIRONMENT_ID');
export const getSlackCommunicateDevopsChannelId = getValue('SLACK_COMMUNICATE_DEVOPS_CHANNEL_ID');
//# sourceMappingURL=env.js.map